import { render, staticRenderFns } from "./DaftarPengadaan.vue?vue&type=template&id=3ed61715&scoped=true"
import script from "./DaftarPengadaan.vue?vue&type=script&lang=js"
export * from "./DaftarPengadaan.vue?vue&type=script&lang=js"
import style0 from "./DaftarPengadaan.vue?vue&type=style&index=0&id=3ed61715&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed61715",
  null
  
)

export default component.exports